import React from "react";
interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}
export function PageHeader({
  title,
  description,
  actions
}: PageHeaderProps) {
  return <header className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-192" data-mp="3rf5hcweafx3u">
      <div data-id="element-193" data-mp="3mfskditpd9nj">
        <h1 className="text-3xl font-semibold tracking-tight md:text-4xl" data-id="element-194" data-mp="3mezhisxv74ao">{title}</h1>
        {description && <p className="mt-2 max-w-2xl text-[15px] text-muted" data-id="element-195" data-mp="2yp59coohq3wr">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2" data-id="element-196" data-mp="2trmyututrgmn">{actions}</div>}
    </header>;
}